import React, { useEffect, useState } from "react";
import api, { errMsg } from "../core/api";
import { isApp, saveInApp } from "../core/bridge";
import Modal from "./Modal";

export default function FileViewer({ path, name, onClose }) {
  const [url, setUrl] = useState(null);
  const [blob, setBlob] = useState(null);
  const [type, setType] = useState("");
  const [err, setErr] = useState("");
  const inApp = isApp();

  useEffect(() => {
    let dead = false;
    let obj = null;
    api
      .get(path, { responseType: "blob", timeout: 120000 })
      .then(({ data }) => {
        if (dead) return;
        obj = URL.createObjectURL(data);
        setType(data.type || "");
        setBlob(data);
        setUrl(obj);
      })
      .catch(async (e) => {
        if (dead) return;
        let msg = errMsg(e);
        try {
          const t = await e.response?.data?.text?.();
          if (t) msg = JSON.parse(t).error || msg;
        } catch {}
        setErr(msg);
      });
    return () => {
      dead = true;
      if (obj) setTimeout(() => URL.revokeObjectURL(obj), 60000);
    };
  }, [path]);

  const isImg = type.startsWith("image/");
  const isPdf = type === "application/pdf";
  const fileName =
    (name || "file") + (isPdf && !/\.pdf$/i.test(name || "") ? ".pdf" : "");

  return (
    <Modal
      wide
      title={name || "مشاهده فایل"}
      onClose={onClose}
      footer={
        <>
          {blob && inApp && (
            <button className="btn" onClick={() => saveInApp(blob, fileName)}>
              <i className="fa-solid fa-share-nodes" /> باز کردن / ذخیره
            </button>
          )}
          {url && !inApp && (
            <a className="btn" href={url} target="_blank" rel="noreferrer">
              <i className="fa-solid fa-up-right-from-square" /> باز کردن در تب
              جدید
            </a>
          )}
          {url && !inApp && (
            <a className="btn btn-ghost" href={url} download={name || "file"}>
              <i className="fa-solid fa-download" /> دانلود
            </a>
          )}
          <button className="btn btn-ghost" onClick={onClose}>
            بستن
          </button>
        </>
      }
    >
      {err ? (
        <div className="alert err">{err}</div>
      ) : !url ? (
        <div className="empty">
          <div className="spinner" style={{ margin: "0 auto" }} />
        </div>
      ) : isImg ? (
        <div style={{ textAlign: "center" }}>
          <img
            src={url}
            alt={name || ""}
            style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: 10 }}
          />
        </div>
      ) : isPdf && !inApp ? (
        <iframe
          title={name || "file"}
          src={url}
          style={{
            width: "100%",
            height: "70vh",
            border: "1px solid var(--border)",
            borderRadius: 10,
            background: "#fff",
          }}
        />
      ) : isPdf ? (
        <div className="alert info">
          پیش‌نمایش PDF داخل اپ ممکن نیست؛ با دکمه‌ی «باز کردن / ذخیره» آن را در
          برنامه‌ی PDF خود ببینید.
        </div>
      ) : (
        <div className="alert info">
          پیش‌نمایش این نوع فایل ممکن نیست؛ از دکمه‌ی دانلود استفاده کنید.
        </div>
      )}
    </Modal>
  );
}
